import { ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';

export const BASE_SIDEBAR_SECTION: ISidebarSection = {
    id: 'personal',
    title: 'Minha Área',
    icon: 'menu-dashboard',
    isAccordion: true,
    items: [
        {
            id: 'home',
            title: 'Página Inicial',
            route: '/',
            isVisible: true,
        },
        {
            id: 'profile',
            title: 'Meu Perfil',
            route: '/perfil',
            isVisible: true,
        },
    ],
    isVisible: true,
};
